<template>
  <div v-html="html" />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: ['name'],
  data: () => ({
    html: '',
  }),
  methods: {
    ...mapActions('product', ['getReportSample']),

    loadReport() {
      return this.getReportSample(this.name)
        .then((response) => this.html = response.content);
    },
  },
  created() {
    this.loadReport();
  },
};
</script>
